import homeImg_1 from './uvodBanner_new2.jpg';
import homeImg_2 from './33466983_m.jpg';
import homeImg_3 from './43879776_m.jpg';
import homeImg_4 from './shutterstock_469006907.jpg';
import homeImg_5 from './shutterstock_615536654.jpg';
import homeImg_6 from './shutterstock_639921919.jpg';

export default [
   homeImg_1, homeImg_2, homeImg_3, homeImg_4, homeImg_5, homeImg_6
]



// WEBPACK FOOTER //
// ./src/assets/img/llc/homeSlider/index.js